import { useAppSelector } from '~/app/hooks'
import { isDarkTheme } from '~/redux/features'

export function EFPencilIcon() {
  const isDark = useAppSelector(isDarkTheme)
  const fill = isDark ? 'var(--color-dark-theme)' : 'var(--icon-color-light-theme)'
  return (
    <svg
      width='20'
      height='21'
      viewBox='0 0 20 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17.1813 3.42689C16.0291 2.21505 14.1047 2.19077 12.9222 3.37317L3.54741 12.7475C3.21958 13.0754 2.99204 13.4899 2.89148 13.9424L2.01387 17.8923C1.97678 18.0592 2.02754 18.2335 2.14844 18.3544C2.26934 18.4753 2.44362 18.526 2.6105 18.4889L6.53689 17.6157C7.00432 17.5118 7.43243 17.2767 7.77103 16.9381L17.129 7.58003C18.27 6.439 18.2933 4.59631 17.1813 3.42689ZM13.6293 4.08029C14.4143 3.29538 15.6917 3.3115 16.4566 4.11596C17.1948 4.89225 17.1793 6.11548 16.4219 6.87293L15.7507 7.54418L12.958 4.75155L13.6293 4.08029ZM12.2509 5.45864L15.0436 8.2513L7.06391 16.231C6.85976 16.4352 6.60164 16.5769 6.31982 16.6396L3.1605 17.3421L3.86768 14.1593C3.92698 13.8924 4.06117 13.648 4.2545 13.4547L12.2509 5.45864Z'
        fill={fill}
      />
    </svg>
  )
}
